import Vue from 'vue';
import Vuex from 'vuex';

import singlesEntrySystem from './singles-entry-system'
import doublesEnterDropDowns from './doubles/enterable-drop-downs'
import enterableDoublesTournaments from './doubles/enterable-tournaments'
import partnerChecks from './doubles/partner-checks'
import withdrawableEntries from './doubles/withdrawable-entries'
import doublesActivity from './doubles/entry-activity'
import wtaSystem from './wta-system'
import information from './information'

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        singlesEntrySystem,

        doublesEnterDropDowns,
        enterableDoublesTournaments,
        partnerChecks,
        withdrawableEntries,
        doublesActivity,

        wtaSystem,
        information
    },
});



// WEBPACK FOOTER //
// ./src/store/index.js